import { getColorForTheme } from '@grafana/data';
import tinycolor from 'tinycolor2';
import darkTheme from '../../../themes/dark';
import { getCanvasContext } from '../../../utils/measureText';
export function getOpacityGradientFn(color, opacity) {
    return function (plot, seriesIdx) {
        var ctx = getCanvasContext();
        var gradient = ctx.createLinearGradient(0, plot.bbox.top, 0, plot.bbox.top + plot.bbox.height);
        gradient.addColorStop(0, tinycolor(color).setAlpha(opacity).toRgbString());
        gradient.addColorStop(1, tinycolor(color).setAlpha(0).toRgbString());
        return gradient;
    };
}
export function getHueGradientFn(color, opacity, theme) {
    return function (plot, seriesIdx) {
        var ctx = getCanvasContext();
        var gradient = ctx.createLinearGradient(0, plot.bbox.top, 0, plot.bbox.top + plot.bbox.height);
        var color1 = tinycolor(color).spin(-15);
        var color2 = tinycolor(color).spin(15);
        if (theme.isDark) {
            gradient.addColorStop(0, color2.lighten(10).setAlpha(opacity).toString());
            gradient.addColorStop(1, color1.darken(10).setAlpha(opacity).toString());
        }
        else {
            gradient.addColorStop(0, color2.lighten(10).setAlpha(opacity).toString());
            gradient.addColorStop(1, color1.setAlpha(opacity).toString());
        }
        return gradient;
    };
}
/**
 * Experimental & quick and dirty test
 * Not being used
 */
export function getScaleGradientFn(opacity, colorMode, thresholds) {
    if (!colorMode) {
        throw Error('Missing colorMode required for color scheme gradients');
    }
    if (!thresholds) {
        throw Error('Missing thresholds required for color scheme gradients');
    }
    return function (plot, seriesIdx) {
        var ctx = getCanvasContext();
        var gradient = ctx.createLinearGradient(0, plot.bbox.top, 0, plot.bbox.top + plot.bbox.height);
        var series = plot.series[seriesIdx];
        var scale = plot.scales[series.scale];
        var range = plot.bbox.height;
        console.log('scale', scale);
        console.log('series.min', series.min);
        console.log('series.max', series.max);
        var getColorWithAlpha = function (color) {
            return tinycolor(getColorForTheme(color, darkTheme)).setAlpha(opacity).toString();
        };
        var addColorStop = function (value, color) {
            var pos = plot.valToPos(value, series.scale);
            var percent = pos / range;
            console.log("addColorStop(value = " + value + ", xPos=" + pos + ")");
            gradient.addColorStop(Math.min(percent, 1), getColorWithAlpha(color));
        };
        for (var idx = 0; idx < thresholds.steps.length; idx++) {
            var step = thresholds.steps[idx];
            var value = step.value === -Infinity ? 0 : step.value;
            addColorStop(value, step.color);
            // to make the gradient discrete
            if (thresholds.steps.length > idx + 1) {
                addColorStop(thresholds.steps[idx + 1].value - 0.0000001, step.color);
            }
        }
        return gradient;
    };
}
//# sourceMappingURL=gradientFills.js.map